import { read } from "Utils/Helpers/LocalStorage";
import instance from "http/Manager";

export const get_byDate = (date) => {
    const data = {
        date,
        clinic: read('main-local'),
    }
    return instance.post(`/appointments/search-date`, data);
};

export const get_byPatient = (id) => {
    const data = {
        patient: id,
        clinic: read('main-local'),
    }
    return instance.post(`/appointments/search-patient`, data);
};

export const save_new = (date, dow, type, patient, description) => {
    const data = {
        date, dow, type, patient, description,
        clinic: read('main-local'),
    }
    return instance.post(`/appointments/save-new`, data);
};

export const save_new_wp = (date, dow, type, name, nationalCode, identificationCode, mobile, description) => {
    const data = {
        date, dow, type, name, nationalCode, identificationCode, mobile, description,
        clinic: read('main-local'),
    }
    return instance.post(`/appointments/save-wp-new`, data);
};

export const update_status = (params) => {
    const data = {
        appointment: params.id,
        localId: params.stid,
        dow: params.dow,
        ...properties('toDate', params.date),
        ...properties('time', params.time),
        ...properties('description', params.description),
        clinic: read('main-local'),
    }
    return instance.post(`/appointments/update-status`, data);
};

export const update_payment = (params) => {
    const data = {
        appointment: params.id,
        date: params.date,
        price: params.price,
        payType: params.payType,
        ...properties('description', params.description),
        clinic: read('main-local'),
    }
    return instance.post(`/appointments/update-payment`, data);
};

export const update_appointment_type = (appointment, type) => {
    return instance.post(`/appointments/update-appointment-type`, { appointment, type, clinic: read('main-local'),});
};

export const update_appointment_status = (data) => {
    return instance.post(`/appointments/update-status-alternativ`, { 
        appointment: data.data.id,
        status: data.item.id,
        date: data.params.date,
        dow: data.dow,
        ...properties('time', data.params.time),
        ...properties('description', data.params.description),
        clinic: read('main-local')
    });
};

export const delete_appointment = (appointment) => {
    return instance.put(`/appointments/delete-appointment`, { appointment, clinic: read('main-local'),});
};

export const delete_status = (status) => {
    return instance.put(`/appointments/delete-status`, { status, clinic: read('main-local'),});
};

export const delete_payment = (payment) => {
    return instance.put(`/appointments/delete-payment`, { payment, clinic: read('main-local'),});
};

const properties = (key, item) => {
    if(item) return { [key]: item }
    else return null;
};